import { Grid, MenuItem, Select, Stack, Typography } from "@mui/material"
import { useEffect, useState } from "react"

import config 			from "../../../common/Config";
import Loading 			from "../../../components/Loading";
import RankingTable 	from "./RankingTable";

const Ranking = (props) => {

	const [rankingData, setRankingData] 		= useState()
	const [selectedIndex, setSelectedIndex]		= useState('IBOV');

	const pageSize = 20;			

	useEffect(() => {
		fetch(config.apiUrl +'/api/ranking')
		.then(results => results.json())
		.then(results => {
			setRankingData(results)
		})
	}, [])


	if (!rankingData) return <Loading />

	return (
		<Grid container spacing={1}>
			<Grid item xs={12}>
				<Stack direction={'row'} display="flex" alignItems="center" justifyContent="space-between">
					<Typography variant="h5" fontWeight={800} align="left" flex={1}>Lista TOP {pageSize}</Typography>
					<Select size="small" value={selectedIndex} onChange={(e) => setSelectedIndex(e.target.value)}>
						<MenuItem value="IBOV">Ibovespa</MenuItem>
						<MenuItem value="SP500">SP500</MenuItem>
					</Select>
				</Stack>
			</Grid>
			<Grid item xs={12} sm={6} marginBottom={2}>
				<Typography variant="h6" fontWeight={800} align="center">Top {pageSize} Melhores P/L</Typography>
				<RankingTable 
					title="P/L"
					field="priceEarnings"
					data={rankingData.filter(r => r.indexName == selectedIndex)[0].stocks.filter(s => s.priceEarnings > 0).sort((a,b) => a.priceEarnings - b.priceEarnings).slice(0,pageSize)}
				/>
			</Grid>
			<Grid item xs={12} sm={6} marginBottom={2}>
				<Typography variant="h6" fontWeight={800} align="center">Top {pageSize} Melhores Dividend Yields</Typography>
				<RankingTable 
					title="D/Y"
					field="dividendYield"
					data={rankingData.filter(r => r.indexName == selectedIndex)[0].stocks.filter(s => s.dividendYield > 0).sort((a,b) => parseFloat(b.dividendYield) - parseFloat(a.dividendYield)).slice(0,pageSize)}
				/>
			</Grid>						
			<Grid item xs={12} sm={6} marginBottom={2}>
				<Typography variant="h6" fontWeight={800} align="center">Top {pageSize} Melhores Relações Preço vs VPA</Typography>
				<RankingTable 
					title="P/VPA"
					field="priceToBookValue"
					data={rankingData.filter(r => r.indexName == selectedIndex)[0].stocks.filter(s => s.priceToBookValue > 0).filter(s => s.priceToBookValue > 0).sort((a,b) => parseFloat(a.priceToBookValue) - parseFloat(b.priceToBookValue)).slice(0,pageSize)}
				/>
			</Grid>
			<Grid item xs={12} sm={6} marginBottom={2}>
				<Typography variant="h6" fontWeight={800} align="center">Top {pageSize} Melhores Relações Preço vs Graham</Typography>
				<RankingTable 
					title="P/Graham"
					field="priceToGraham"
					data={rankingData.filter(r => r.indexName == selectedIndex)[0].stocks.filter(s => s.priceToGraham > 0).sort((a,b) => parseFloat(a.priceToGraham) - parseFloat(b.priceToGraham)).slice(0,pageSize)}
				/>
			</Grid>
			<Grid item xs={12} sm={6} marginBottom={2}>
				<Typography variant="h6" fontWeight={800} align="center">Top {pageSize} Maiores Crescimentos de Receita</Typography>
				<RankingTable 
					title="CAGR 10 Anos"
					field="CAGRRevenue10y"
					format={value => (parseFloat(value) * 100).toFixed(2)}
					data={rankingData.filter(r => r.indexName == selectedIndex)[0].stocks.filter(s => s.CAGRRevenue10y > 0).sort((a,b) => parseFloat(b.CAGRRevenue10y) - parseFloat(a.CAGRRevenue10y)).slice(0,pageSize)}
				/>
			</Grid>
			<Grid item xs={12} sm={6} marginBottom={2}>
				<Typography variant="h6" fontWeight={800} align="center">Top {pageSize} Maiores Crescimento de Lucros</Typography>
				<RankingTable 
					title="CAGR 10 Anos"
					field="CAGRNetIncome10y"
					format={value => (parseFloat(value) * 100).toFixed(2)}
					data={rankingData.filter(r => r.indexName == selectedIndex)[0].stocks.filter(s => s.CAGRNetIncome10y > 0).sort((a,b) => parseFloat(b.CAGRNetIncome10y) - parseFloat(a.CAGRNetIncome10y)).slice(0,pageSize)}
				/>
			</Grid>						
		</Grid>
	)

}

export default Ranking